import { lightblue } from '@/config/colors';
export const textMarkerMaker = (color, isSelected, number) => {
  if (isSelected) {
    return `<?xml version="1.0" encoding="utf-8"?>
    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="512px" height="518.6px" viewBox="0 0 512 518.6" style="enable-background:new 0 0 512 518.6;" xml:space="preserve">
    <style type="text/css">
    @import url("https://fonts.googleapis.com/css?family=Roboto:200,200i,300,300i,400,400i,600,600i,700,700i");
    .st0{fill:#${color};stroke:#FFFFFF;stroke-width:6;stroke-miterlimit:10;} .st1{fill:#EA5436;} .st2{fill:#FFFFFF;}
    </style>
    <g id="Ebene_2">
    </g>
    <g id="Capa_1">
    <path class="st0" d="M265,3.3C161.1,3.3,76.5,87.8,76.5,191.8c0,27.1,5.5,53,16.5,76.9c47.1,103.1,137.5,212,164.1,242.9 c2,2.3,4.9,3.6,7.9,3.6c3.1,0,6-1.3,7.9-3.6c26.6-30.9,116.9-139.8,164.1-242.9c10.9-23.9,16.5-49.8,16.5-76.9 C453.5,87.8,368.9,3.3,265,3.3z"/>
    </g>
    <g>
    <path class="st1" d="M417,167.2c-44.5,0-80.7-36.2-80.7-80.7S372.5,5.8,417,5.8s80.7,36.2,80.7,80.7S461.5,167.2,417,167.2z"/><path class="st2" d="M417,8.3c43.1,0,78.2,35.1,78.2,78.2s-35.1,78.2-78.2,78.2s-78.2-35.1-78.2-78.2S373.9,8.3,417,8.3 M417,3.3 c-46,0-83.2,37.2-83.2,83.2s37.2,83.2,83.2,83.2s83.2-37.2,83.2-83.2S463,3.3,417,3.3L417,3.3z"/>
      <text x="52%" y="50%" text-anchor="middle" style="font-family:Roboto,sans-serif;font-size:10em;font-style:normal;font-weight:normal;" fill="white"> ${number} </text>
    </g>
    </svg>`;
  }

  return `<?xml version="1.0" encoding="utf-8"?>
    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="512px" height="518.6px" viewBox="0 0 512 518.6" style="enable-background:new 0 0 512 518.6;" xml:space="preserve">
    <style type="text/css">
    @import url("https://fonts.googleapis.com/css?family=Roboto:200,200i,300,300i,400,400i,600,600i,700,700i");
    .st0{fill:#${color};stroke:#FFFFFF;stroke-width:6;stroke-miterlimit:10;}</style>
    .font{font:10em 'Roboto';}
    <g id="Ebene_2"></g>
    <g id="Capa_1"><path class="st0" d="M265,3.3C161.1,3.3,76.5,87.8,76.5,191.8c0,27.1,5.5,53,16.5,76.9c47.1,103.1,137.5,212,164.1,242.9c2,2.3,4.9,3.6,7.9,3.6c3.1,0,6-1.3,7.9-3.6c26.6-30.9,116.9-139.8,164.1-242.9c10.9-23.9,16.5-49.8,16.5-76.9C453.5,87.8,368.9,3.3,265,3.3z"/></g>
    <text x="52%" y="50%" text-anchor="middle" style="font-family:Roboto,sans-serif;font-size:10em;font-style:normal;font-weight:normal;" fill="white">${number}</text>
  </svg>`;
};

export const typeMarkerMaker = (color, isSelected) => {
  if (isSelected) {
    return `<?xml version="1.0" encoding="utf-8"?>
    <svg version="1.0" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
 width="512px" height="518.6px" viewBox="0 0 512 518.6" style="enable-background:new 0 0 512 518.6;" xml:space="preserve">
<style type="text/css">
.st0{fill:${color};}
.st1{fill:#2D4153;}
</style>
<g id="Ebene_2_1_">
</g>
<g id="Capa_1">
<g>
<path class="st0" d="M265,490c-32.5-38.6-111.3-136.6-153.8-229.6c-9.8-21.2-14.7-44.3-14.7-68.6c0-92.9,75.6-168.5,168.5-168.5
s168.5,75.6,168.5,168.5c0,24.1-4.9,47.2-14.7,68.6C376.1,353.6,297.5,451.5,265,490z"/>
<path class="st1" d="M265,43.3c81.9,0,148.5,66.6,148.5,148.5c0,21.3-4.3,41.5-12.9,60.3l0,0c-19.1,41.7-48,89.4-85.8,141.7
c-18.5,25.6-36.1,48-49.8,64.9c-13.7-16.9-31.4-39.3-49.9-64.9c-37.9-52.3-66.7-100-85.8-141.7l0-0.1l0-0.1
c-8.5-18.5-12.8-38.8-12.8-60.2C116.5,109.9,183.1,43.3,265,43.3 M265,3.3C161.1,3.3,76.5,87.8,76.5,191.8
c0,27.1,5.5,53,16.5,76.9c47.1,103.1,137.5,212,164.1,242.9c2,2.3,4.9,3.6,7.9,3.6c3.1,0,6-1.3,7.9-3.6
c26.6-30.9,116.9-139.8,164.1-242.9c10.9-23.9,16.5-49.8,16.5-76.9C453.5,87.8,368.9,3.3,265,3.3L265,3.3z"/>
</g>
</g>
</svg>`;
  }

  return `<?xml version="1.0" encoding="utf-8"?>
    <svg version="1.0" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
 width="512px" height="518.6px" viewBox="0 0 512 518.6" style="enable-background:new 0 0 512 518.6;" xml:space="preserve">
<style type="text/css">
.st0{fill:${color};}
.st1{fill:#2D4153;}
</style>
<g id="Ebene_2_1_">
</g>
<g id="Capa_1">
<g>
<path class="st0" d="M265,490c-32.5-38.6-111.3-136.6-153.8-229.6c-9.8-21.2-14.7-44.3-14.7-68.6c0-92.9,75.6-168.5,168.5-168.5
s168.5,75.6,168.5,168.5c0,24.1-4.9,47.2-14.7,68.6C376.1,353.6,297.5,451.5,265,490z"/>
<path class="st1" d="M265,43.3c81.9,0,148.5,66.6,148.5,148.5c0,21.3-4.3,41.5-12.9,60.3l0,0c-19.1,41.7-48,89.4-85.8,141.7
c-18.5,25.6-36.1,48-49.8,64.9c-13.7-16.9-31.4-39.3-49.9-64.9c-37.9-52.3-66.7-100-85.8-141.7l0-0.1l0-0.1
c-8.5-18.5-12.8-38.8-12.8-60.2C116.5,109.9,183.1,43.3,265,43.3 M265,3.3C161.1,3.3,76.5,87.8,76.5,191.8
c0,27.1,5.5,53,16.5,76.9c47.1,103.1,137.5,212,164.1,242.9c2,2.3,4.9,3.6,7.9,3.6c3.1,0,6-1.3,7.9-3.6
c26.6-30.9,116.9-139.8,164.1-242.9c10.9-23.9,16.5-49.8,16.5-76.9C453.5,87.8,368.9,3.3,265,3.3L265,3.3z"/>
</g>
</g>
</svg>`;
};

export const markerMaker = (color, isSelected) => {
  let svg;
  if (isSelected) {
    svg =
      '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="512px" height="518.6px" viewBox="0 0 512 518.6" style="enable-background:new 0 0 512 518.6;" xml:space="preserve">';
    svg += `<style type="text/css">.st0{fill:#${color};stroke:#FFFFFF;stroke-width:6;stroke-miterlimit:10;} .st1{fill:#EA5436;} .st2{fill:#FFFFFF;}</style>`;
    svg += '<g id="Ebene_2"></g><g id="Capa_1">';
    svg +=
      '<path class="st0" d="M265,3.3C161.1,3.3,76.5,87.8,76.5,191.8c0,27.1,5.5,53,16.5,76.9c47.1,103.1,137.5,212,164.1,242.9 c2,2.3,4.9,3.6,7.9,3.6c3.1,0,6-1.3,7.9-3.6c26.6-30.9,116.9-139.8,164.1-242.9c10.9-23.9,16.5-49.8,16.5-76.9 C453.5,87.8,368.9,3.3,265,3.3z"/>';
    svg +=
      '</g><g><path class="st1" d="M417,167.2c-44.5,0-80.7-36.2-80.7-80.7S372.5,5.8,417,5.8s80.7,36.2,80.7,80.7S461.5,167.2,417,167.2z"/><path class="st2" d="M417,8.3c43.1,0,78.2,35.1,78.2,78.2s-35.1,78.2-78.2,78.2s-78.2-35.1-78.2-78.2S373.9,8.3,417,8.3 M417,3.3 c-46,0-83.2,37.2-83.2,83.2s37.2,83.2,83.2,83.2s83.2-37.2,83.2-83.2S463,3.3,417,3.3L417,3.3z"/>';
    svg += '</g></svg>';
  } else {
    svg =
      '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="512px" height="518.6px" viewBox="0 0 512 518.6" style="enable-background:new 0 0 512 518.6;" xml:space="preserve">';
    svg += `<style type="text/css">.st0{fill:#${color};stroke:#FFFFFF;stroke-width:6;stroke-miterlimit:10;}</style>`;
    svg += '<g id="Ebene_2"></g>';
    svg +=
      '<g id="Capa_1"><path class="st0" d="M265,3.3C161.1,3.3,76.5,87.8,76.5,191.8c0,27.1,5.5,53,16.5,76.9c47.1,103.1,137.5,212,164.1,242.9c2,2.3,4.9,3.6,7.9,3.6c3.1,0,6-1.3,7.9-3.6c26.6-30.9,116.9-139.8,164.1-242.9c10.9-23.9,16.5-49.8,16.5-76.9C453.5,87.8,368.9,3.3,265,3.3z"/></g>';
    svg += '</svg>';
  }
  return svg;
};

export const pickupMarkerMaker = () => `
<svg version="1.1" id="Ebene_1"
  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 518.6"
  xml:space="preserve" overflow="visible">
<style type="text/css">
 .st0{fill:#ea5436;stroke:#FFFFFF;stroke-width:6;stroke-miterlimit:10;}
 .st1{fill:#FFFFFF;}
</style>
<g id="Capa_1">
 <path class="st0" d="M265,3.3C161.1,3.3,76.5,87.8,76.5,191.8c0,27.1,5.5,53,16.5,76.9c47.1,103.1,137.5,212,164.1,242.9
  c2,2.3,4.9,3.6,7.9,3.6c3.1,0,6-1.3,7.9-3.6c26.6-30.9,116.9-139.8,164.1-242.9c10.9-23.9,16.5-49.8,16.5-76.9
  C453.5,87.8,368.9,3.3,265,3.3z"/>
</g>
<g>
 <path class="st1" d="M292.3,150.9c4.6,2.9,8.1,6.8,10.9,11.8c2.7,5,4,10.4,4,16.4s-1.3,11.5-4,16.5c-2.7,5.1-6.3,9-10.9,12
  c-4.6,2.9-9.5,4.4-14.8,4.4H249v33.5c0,2-0.6,3.7-2,5.2c-1.3,1.4-3,2.1-5,2.1c-2.1,0-3.8-0.7-5.1-2c-1.2-1.3-1.9-3.1-1.9-5.2V154
  c0-2,0.7-3.7,2.1-5.2c1.4-1.4,3.1-2.1,5.2-2.1h35.2C282.8,146.6,287.8,148,292.3,150.9z M285,195.5c2.3-1.8,4.2-4.1,5.6-7
  c1.3-2.9,2-6.1,2-9.4c0-5.2-1.5-9.5-4.5-13.1s-6.5-5.4-10.7-5.4h-28.5v37.6h28.5C280.2,198.1,282.7,197.2,285,195.5z"/>
</g>
<path class="st1" d="M341.6,95.4H188.5c-7.4,0-14.1,3.3-18.7,8.5c-3.9,4.4-6.2,10.1-6.2,16.4l0,0v46.8l12.4,17.1l6.2,8.6
 c1.6,2.2,1.6,5.3,0,7.5L176,209l-12.4,17.1v47.3l0,0c0,6.3,2.3,12.1,6.2,16.4c4.6,5.2,11.3,8.5,18.7,8.5h153.1
 c13.7,0,24.9-11.2,24.9-24.9v-43.3v-67v-42.8C366.5,106.6,355.3,95.4,341.6,95.4z M354.1,273.4c0,6.9-5.6,12.5-12.5,12.5H188.5
 c-6.9,0-12.5-5.6-12.5-12.5l0,0v-43.3l16.3-22.5c4.8-6.6,4.8-15.5,0-22.1L176,163.1v-42.8l0,0c0-6.9,5.6-12.5,12.5-12.5h153.1
 c6.9,0,12.5,5.6,12.5,12.5V273.4L354.1,273.4z"/>
</svg>
`;

export const deliveryMarkerMaker = () => `
<svg version="1.1" id="Ebene_1"
xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
x="0px" y="0px" viewBox="0 0 512 518.6" style="enable-background:new 0 0 512 518.6;" xml:space="preserve">
  <style type="text/css">
    .st0{fill:${lightblue};stroke:#FFFFFF;stroke-width:6;stroke-miterlimit:10;}
    .st1 { fill: #FFFFFF; }
  </style>

  <g id="Capa_1">
    <path class="st0" d="M265,3.3C161.1,3.3,76.5,87.8,76.5,191.8c0,27.1,5.5,53,16.5,76.9
    c47.1,103.1,137.5,212,164.1,242.9c2,2.3,4.9,3.6,7.9,3.6c3.1,0,6-1.3,7.9-3.6
    c26.6-30.9,116.9-139.8,164.1-242.9c10.9-23.9,16.5-49.8,16.5-76.9
    C453.5,87.8,368.9,3.3,265,3.3z"/>
  </g>

  <g>
    <path class="st1" d="M293.3,150.8c6.8,4.8,11.9,11.2,15.4,19.3c3.4,8.1,5.2,17,5.2,26.9s-1.7,19-5.2,27
    c-3.4,8.1-8.6,14.5-15.4,19.2s-15,7.1-24.5,7.1h-37.5c-2,0-3.7-0.7-5.2-2.1
    c-1.4-1.4-2.1-3.1-2.1-5.2v-92c0-2,0.7-3.7,2.1-5.2c1.4-1.4,3.1-2.1,5.2-2.1h37.5
    C278.3,143.7,286.5,146.1,293.3,150.8z M290.6,225.3c5.2-7.3,7.8-16.8,7.8-28.3
    c0-11.4-2.6-20.8-7.8-28.2c-5.2-7.4-13-11.1-23.2-11.1h-28.2v78.7h28.2
    C277.6,236.3,285.4,232.7,290.6,225.3z"/>
  </g>

  <path class="st1" d="M342.3,107.4c6.9,0,12.6,5.6,12.6,12.6v47.1l18.7,25.9c1.6,2.2,1.6,5.3,0,7.6l-18.7,25.9v47.6
  c0,6.9-5.6,12.6-12.6,12.6H188.1c-6.9,0-12.6-5.6-12.6-12.6V120c0-6.9,5.6-12.6,12.6-12.6H342.3
  M342.3,94.9H188.1c-13.8,0-25.1,11.2-25.1,25.1v154.2c0,13.8,11.2,25.1,25.1,25.1h154.2
  c13.8,0,25.1-11.2,25.1-25.1v-43.6l16.4-22.6c4.8-6.6,4.8-15.6,0-22.3l-16.4-22.6V120
  C367.5,106.2,356.2,94.9,342.3,94.9L342.3,94.9z"/>
</svg>
`;

export const clusterIconMaker = (count, selected) => {
  if (selected) {
    return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
  width="512px" height="518.6px" viewBox="0 0 512 518.6" style="enable-background:new 0 0 512 518.6;" xml:space="preserve">
<style type="text/css">
 .st0{fill:#2D4154;stroke:#FFFFFF;stroke-width:6;stroke-miterlimit:10;}
 .st1{fill:#FFFFFF;}
 .st2{fill:#EA5436;}
</style>
<g id="Ebene_2">
</g>
<g id="Capa_1">
 <path class="st0" d="M265,3.3C161.1,3.3,76.5,87.8,76.5,191.8c0,27.1,5.5,53,16.5,76.9c47.1,103.1,137.5,212,164.1,242.9
  c2,2.3,4.9,3.6,7.9,3.6c3.1,0,6-1.3,7.9-3.6c26.6-30.9,116.9-139.8,164.1-242.9c10.9-23.9,16.5-49.8,16.5-76.9
  C453.5,87.8,368.9,3.3,265,3.3z"/>
</g>
<g>
<text x="265" y="220" font-family="Verdana" font-size="${
      count > 100 ? 60 : 90
    }" fill ="white" text-anchor="middle">
            ${count}
  </text>
 <path class="st1" d="M265,73.9L391.8,181L265,289.2L138.2,181L265,73.9 M265,62.5c-2.6,0-5.2,0.9-7.3,2.7L130.9,172.4
  c-2.5,2.1-4,5.3-4,8.6c0,3.3,1.4,6.5,4,8.6l126.8,108.2c2.1,1.8,4.7,2.7,7.4,2.7s5.2-0.9,7.4-2.7l126.8-108.2c2.5-2.2,4-5.3,4-8.6
  c0-3.3-1.5-6.5-4-8.6L272.3,65.2C270.2,63.4,267.6,62.5,265,62.5L265,62.5z"/>
 <path class="st1" d="M378.5,301l-11-9.3l-8.9,7.6l11.6,9.8L265,398.7L159.9,309l12.2-10.3l-8.9-7.6l-11.6,9.8c-2.4,2-3.7,4.9-3.7,8
  c0,3.1,1.3,6,3.7,8l106.7,91c1.9,1.6,4.3,2.5,6.8,2.5s4.9-0.9,6.8-2.5l106.7-91c2.4-2,3.7-4.9,3.7-8
  C382.2,305.9,380.8,303,378.5,301z"/>
 <path class="st1" d="M399.1,230.1l-14.5-12.2l-8.7,7.5l15.9,13.4L265,347L138.2,238.8l16.6-14.1l-8.7-7.5l-15.2,12.9
  c-2.5,2.1-4,5.3-4,8.6c0,3.3,1.4,6.5,4,8.6l126.8,108.2c2.1,1.8,4.7,2.7,7.4,2.7c2.6,0,5.2-0.9,7.4-2.7l126.8-108.2
  c2.5-2.2,4-5.3,4-8.6C403.1,235.4,401.6,232.2,399.1,230.1z"/>
</g>
<g>
 <path class="st2" d="M417,167.2c-44.5,0-80.7-36.2-80.7-80.7S372.5,5.8,417,5.8s80.7,36.2,80.7,80.7S461.5,167.2,417,167.2z"/>
 <path class="st1" d="M417,8.3c43.1,0,78.2,35.1,78.2,78.2s-35.1,78.2-78.2,78.2s-78.2-35.1-78.2-78.2S373.9,8.3,417,8.3 M417,3.3
  c-46,0-83.2,37.2-83.2,83.2s37.2,83.2,83.2,83.2s83.2-37.2,83.2-83.2S463,3.3,417,3.3L417,3.3z"/>
</g>
</svg>`;
  }
  return `
  <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width="512px" height="518.6px" viewBox="0 0 512 518.6" style="enable-background:new 0 0 512 518.6;" xml:space="preserve">
<style type="text/css">
 .st0{fill:#2D4154;stroke:#FFFFFF;stroke-width:6;stroke-miterlimit:10;}
 .st1{fill:#FFFFFF;}
</style>
<g id="Capa_1">
 <path class="st0" d="M265,3.3C161.1,3.3,76.5,87.8,76.5,191.8c0,27.1,5.5,53,16.5,76.9c47.1,103.1,137.5,212,164.1,242.9
  c2,2.3,4.9,3.6,7.9,3.6c3.1,0,6-1.3,7.9-3.6c26.6-30.9,116.9-139.8,164.1-242.9c10.9-23.9,16.5-49.8,16.5-76.9
  C453.5,87.8,368.9,3.3,265,3.3z"/>
</g>
<text x="265" y="210" font-family="Verdana" font-size="${
    count > 100 ? 60 : 90
  }" fill ="white" text-anchor="middle">
            ${count}
  </text>
<g>
 <path class="st1" d="M265,73.9L391.8,181L265,289.2L138.2,181L265,73.9 M265,62.5c-2.6,0-5.2,0.9-7.3,2.7L130.9,172.4
  c-2.5,2.1-4,5.3-4,8.6c0,3.3,1.4,6.5,4,8.6l126.8,108.2c2.1,1.8,4.7,2.7,7.4,2.7s5.2-0.9,7.4-2.7l126.8-108.2c2.5-2.2,4-5.3,4-8.6
  c0-3.3-1.5-6.5-4-8.6L272.3,65.2C270.2,63.4,267.6,62.5,265,62.5L265,62.5z"/>
 <path class="st1" d="M378.5,301l-11-9.3l-8.9,7.6l11.6,9.8L265,398.7L159.9,309l12.2-10.3l-8.9-7.6l-11.6,9.8c-2.4,2-3.7,4.9-3.7,8
  c0,3.1,1.3,6,3.7,8l106.7,91c1.9,1.6,4.3,2.5,6.8,2.5s4.9-0.9,6.8-2.5l106.7-91c2.4-2,3.7-4.9,3.7-8
  C382.2,305.9,380.8,303,378.5,301z"/>
 <path class="st1" d="M399.1,230.1l-14.5-12.2l-8.7,7.5l15.9,13.4L265,347L138.2,238.8l16.6-14.1l-8.7-7.5l-15.2,12.9
  c-2.5,2.1-4,5.3-4,8.6c0,3.3,1.4,6.5,4,8.6l126.8,108.2c2.1,1.8,4.7,2.7,7.4,2.7c2.6,0,5.2-0.9,7.4-2.7l126.8-108.2
  c2.5-2.2,4-5.3,4-8.6C403.1,235.4,401.6,232.2,399.1,230.1z"/>
</g>
</svg>
`;
};

export const pickupIconSvg = (number, isSelected) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 56 72" width="40" height="54">
  <defs>
    <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
      <feDropShadow dx="0" dy="2" stdDeviation="3" flood-color="#ef5350" flood-opacity="0.5"/>
    </filter>
  </defs>

  <!-- Outer red stroke (same as fill) when selected -->
  ${
    isSelected
      ? `<path d="M24,0 C11,0 0,11 0,24 C0,38 24,64 24,64 C24,64 48,38 48,24 C48,11 37,0 24,0 Z"
            fill="none" stroke="#ef5350" stroke-width="7"/>`
      : ''
  }

  <!-- Main pin shape with white stroke -->
  <path d="M24,0 C11,0 0,11 0,24 C0,38 24,64 24,64 C24,64 48,38 48,24 C48,11 37,0 24,0 Z"
        fill="#ef5350" stroke="#ffffff" stroke-width="3"
        ${isSelected ? 'filter="url(#shadow)"' : ''}/>

  <!-- Circle for number background -->
  <circle cx="24" cy="24" r="12" fill="#ef5350"/>

  <!-- Number -->
  <text x="24" y="28" text-anchor="middle" font-size="18" fill="#ffffff"
    font-family="Arial" font-weight="bold" dominant-baseline="middle">
    ${number}
  </text>
</svg>
`;

export const deliveryIconSvg = (number, isSelected) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 56 72" width="40" height="54">
  <defs>
    <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
      <feDropShadow dx="0" dy="2" stdDeviation="3" flood-color="#0288D1" flood-opacity="0.5"/>
    </filter>
  </defs>

  <!-- Outer blue stroke layer (only when selected) -->
  ${
    isSelected
      ? `<path d="M24,0 C11,0 0,11 0,24 C0,38 24,64 24,64 C24,64 48,38 48,24 C48,11 37,0 24,0 Z"
            fill="none" stroke="#0288D1" stroke-width="7"/>`
      : ''
  }

  <!-- Main pin shape with white stroke -->
  <path d="M24,0 C11,0 0,11 0,24 C0,38 24,64 24,64 C24,64 48,38 48,24 C48,11 37,0 24,0 Z"
        fill="#0288D1" stroke="#ffffff" stroke-width="3"
        ${isSelected ? 'filter="url(#shadow)"' : ''}/>

  <!-- Circle for number background -->
  <circle cx="24" cy="24" r="12" fill="#0288D1"/>

  <!-- Number -->
  <text x="24" y="28" text-anchor="middle" font-size="18" fill="#ffffff"
    font-family="Arial" font-weight="bold" dominant-baseline="middle">
    ${number}
  </text>
</svg>
`;

export const depotIconSvg = (isSelected = false) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 88" width="40" height="50">
  <defs>
    <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
      <feDropShadow dx="0" dy="2" stdDeviation="3" flood-color="#000000" flood-opacity="0.4"/>
    </filter>
  </defs>

  ${
    isSelected
      ? `<path d="M32,0 C18,0 6,12 6,26 C6,41 32,72 32,72 C32,72 58,41 58,26 C58,12 46,0 32,0 Z"
        fill="none" stroke="#000000" stroke-width="7"/>`
      : ''
  }

  <path d="M32,0 C18,0 6,12 6,26 C6,41 32,72 32,72 C32,72 58,41 58,26 C58,12 46,0 32,0 Z"
        fill="#223547" stroke="#ffffff" stroke-width="3"
        ${isSelected ? 'filter="url(#shadow)"' : ''} />

  <!-- Center the house: move icon's (32,32) to pin-head center (32,26) -->
  <g transform="translate(32,26) scale(0.62) translate(-32,-32)"
     stroke="#ffffff" stroke-width="3" fill="none" stroke-linejoin="round">
    <path d="M12 22 L32 10 L52 22 V50 H12 Z"/>
    <rect x="22" y="28" width="20" height="22" />
    <line x1="22" y1="34" x2="42" y2="34"/>
    <line x1="22" y1="40" x2="42" y2="40"/>
    <line x1="22" y1="46" x2="42" y2="46"/>
  </g>

  <ellipse cx="32" cy="76" rx="16" ry="4" fill="#000000" opacity="0.4"/>
</svg>
`;

export const garageIconSvg = (_number, isSelected) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 72 88" width="40" height="50">
  <defs>
    <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
      <feDropShadow dx="0" dy="2" stdDeviation="3" flood-color="#000000" flood-opacity="0.4"/>
    </filter>
  </defs>

  <!-- Outer stroke highlight if selected -->
  ${
    isSelected
      ? `<path d="M32,0 C18,0 6,12 6,26 C6,41 32,72 32,72 C32,72 58,41 58,26 C58,12 46,0 32,0 Z"
             fill="none" stroke="#000000" stroke-width="7"/>`
      : ''
  }

  <!-- Main pin shape -->
  <path d="M32,0 C18,0 6,12 6,26 C6,41 32,72 32,72 C32,72 58,41 58,26 C58,12 46,0 32,0 Z"
        fill="#000000" stroke="#ffffff" stroke-width="3"
        ${isSelected ? 'filter="url(#shadow)"' : ''}/>

  <!-- Inner white circle -->
  <circle cx="32" cy="27" r="11" fill="#ffffff"/>

  <!-- Home/Garage icon inside the circle -->
  <path d="M24 29 v-5 l8 -4 l8 4 v5 h-4 v-3 h-8 v3 h-4 z"
        fill="#000000"/>

  <!-- Shadow base -->
  <ellipse cx="32" cy="76" rx="16" ry="4" fill="#000000" opacity="0.4"/>
</svg>
`;

export const unscheduledIconSvg = (isSelected = false) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 72 88" width="100%" height="100%">
  <defs>
    <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
      <feDropShadow dx="0" dy="2" stdDeviation="3" flood-color="#000000" flood-opacity="0.4"/>
    </filter>
  </defs>

  <!-- Outer stroke highlight if selected -->
  ${
    isSelected
      ? `<path d="M32,0 C18,0 6,12 6,26 C6,41 32,72 32,72 C32,72 58,41 58,26 C58,12 46,0 32,0 Z"
             fill="none" stroke="#000000" stroke-width="7"/>`
      : ''
  }

  <!-- Main pin (purple) -->
  <path d="M32,0 C18,0 6,12 6,26 C6,41 32,72 32,72 C32,72 58,41 58,26 C58,12 46,0 32,0 Z"
        fill="#808080" stroke="#ffffff" stroke-width="3"
        ${isSelected ? 'filter="url(#shadow)"' : ''}/>

  <!-- Base ring / shadow -->
  <ellipse cx="32" cy="76" rx="16" ry="4" fill="#000000" opacity="0.4"/>
</svg>
`;

export const UnplannedIconSvg = (isSelected = false) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 72 88" width="100%" height="100%">
  <defs>
    <!-- blue halo for selected -->
    <filter id="blueGlow" x="-50%" y="-50%" width="200%" height="200%">
      <feDropShadow dx="0" dy="0" stdDeviation="3" flood-color="#808080" flood-opacity="0.75"/>
    </filter>
  </defs>

  <!-- Outer blue stroke ONLY when selected -->
  ${
    isSelected
      ? `<path d="M32,0 C18,0 6,12 6,26 C6,41 32,72 32,72 C32,72 58,41 58,26 C58,12 46,0 32,0 Z"
             fill="none" stroke="#808080" stroke-width="6" filter="url(#blueGlow)"/>`
      : ''
  }

  <!-- Main pin (grey base) -->
  <path d="M32,0 C18,0 6,12 6,26 C6,41 32,72 32,72 C32,72 58,41 58,26 C58,12 46,0 32,0 Z"
        fill="#808080" stroke="#ffffff" stroke-width="3"/>

  <!-- Base ring/shadow -->
  <ellipse cx="32" cy="76" rx="16" ry="4" fill="#000000" opacity="0.4"/>
</svg>
`;
